import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button, Paragraph } from '@app/shared/ui/atoms/Common';
import { cn, telegramVibrate } from '@app/shared/utils/common';
import { Page } from '@app/routes';

type Color = 'accent' | 'grey' | 'white';

interface BackButtonProps {
  iconClassName?: string;
  color?: Color;
  iconOnly?: boolean;
  onClick?: () => void;
  shouldNavigate?: boolean;
  className?: string;
}

const COLOR_TO_CLASS_NAMES_MAP: Record<Color, string> = {
  accent: 'text-accent',
  grey: 'text-gray-neutral',
  white: 'text-foreground',
};

export function BackButton({
  iconClassName,
  color = 'white',
  iconOnly,
  onClick,
  shouldNavigate = true,
  className,
}: BackButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackClick = () => {
    telegramVibrate();
    if (shouldNavigate) {
      navigate(Page.HOME);
    }
    onClick?.();
  };

  const colorClass = COLOR_TO_CLASS_NAMES_MAP[color];

  return (
    <Button
      variant="custom"
      onClick={handleBackClick}
      className={cn('flex h-fit items-center', className)}
    >
      <svg
        viewBox="0 0 13 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('mx-2 my-1 h-[20px] w-[13px]', colorClass, iconClassName)}
      >
        <path
          d="M11 2L3 10L11 18"
          stroke="currentColor"
          strokeWidth={iconOnly ? 3 : 2}
          strokeLinecap="round"
        />
      </svg>

      {!iconOnly && (
        <Paragraph className={cn('text-sm font-bold', colorClass)}>{t('common.back')}</Paragraph>
      )}
    </Button>
  );
}
